import {
  QueryObserverResult,
  RefetchOptions,
  RefetchQueryFilters,
} from '@tanstack/react-query';
import { useEffect, useState } from 'react';

import { CommunityStatusDataPayload } from '../../../../@types/community';
import useLeaveCommunity from '../hooks/useLeaveCommunity';
import { DATA_CY_COMMUNITY } from '../__tests__/constant';
import { affiliateActions, affiliateNavigationEvents } from '../analytics';

import Detail from './Detail';
import Leave from './Modals/Leave';
import Template from './Template';

interface Props {
  data: CommunityStatusDataPayload;
  refetch: <TPageData>(
    options?: RefetchOptions & RefetchQueryFilters<TPageData>,
  ) => Promise<QueryObserverResult<CommunityStatusDataPayload>>;
}

function Community({ data, refetch }: Props) {
  const [confirm, setConfirm] = useState(false);
  const leaveCommunity = useLeaveCommunity();

  const onLeave = () => {
    affiliateNavigationEvents.exitExternalCommunityViewed();
    affiliateActions.exitCommunitySelected();
    setConfirm(true);
  };

  const onCancel = () => {
    affiliateActions.exitCommunityCanceled();
    setConfirm(false);
  };

  const onConfirm = () => {
    affiliateActions.exitCommunityConfirmed();
    leaveCommunity.mutate(undefined, {
      onSuccess() {
        setConfirm(false);
        refetch();
      },
    });
  };

  useEffect(() => {
    affiliateNavigationEvents.membersExternalCommunityViewed(
      data.able_to_leave,
    );
  }, []);

  return (
    <div data-cy={DATA_CY_COMMUNITY}>
      <Template>
        <Detail
          fee={data.community_fee || data.default_fee}
          until={data.commit_until}
          onLeave={onLeave}
          community={data.community}
          ableToLeave={data.able_to_leave}
        />
      </Template>
      <Leave
        onOk={onConfirm}
        visible={confirm}
        onCancel={onCancel}
        communityName={data.community.name}
      />
    </div>
  );
}

export default Community;
